enum notificationEventType {
  created = 1,
  deleted = 2,
  updated = 3
}

export default notificationEventType;
